var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not_data_wrap"},[_c('img',{staticClass:"data_image",attrs:{"src":require("../../assets/images/icon_not_data.png")}}),_vm._v(" "),_c('span',{staticClass:"data_info"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1964f51d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/space/space.vue
// module id = null
// module chunks = 